import { modifyProps } from './props';
import { spreadByBreakpoints } from './media-spread';
export var modifyByBreakpoints = function modifyByBreakpoints(props, modifyFn) {
  return modifyProps(spreadByBreakpoints(props), modifyFn);
};